import Vue from 'vue'
import Vuex from 'vuex'
import Api from '../api/api'

Vue.use(Vuex)

export const store = new Vuex.Store({
    state: {
        activ: true
    },
    getters: {
        domains: state => {
            return state.domains
        }
    },
    mutations: {
        loadOn(state) {
            state.loading = true
        },
        loadOff(state) {
            state.loading = false
        }
    },
    actions: {
        postApi(context,data) {
            var requestData = new URLSearchParams();
            requestData.append('controller',data['controller'])
            requestData.append('action',data['action'])
            if(data.post!=undefined) {
                for (var key in data.post) {
                    requestData.append("post["+key+"]",data.post[key])
                }
            }
            return Api.post('async.hub.php',requestData).then((response) => {
                return response
            })
        }
    }
})



// WEBPACK FOOTER //
// ./src/store/store.js